import * as Yup from 'yup';

export const getPaymentMethodsSchema = () => {
  return Yup.object().shape({
    methods: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.number().nullable(),
          label: Yup.string().trim().min(2, 'Мінімум 2 символи').max(30, 'Не більше 30 символів'),
        })
      )
      .required("Обов'язкове поле"),
  });
};
